import {
  showToast,
  yesNoConfirm,
  wrappedGet,
  wrappedPost,
} from "../../general/utils.js";

const LOCAL_CACHE = {};

const setAiVariablesTableContent = () => {
  // Sets the table rows from the local cache.
  // To be called immediately after ai_variables post requests.

  const table = $("#aiVariablesTable")[0];
  if (!table) return;
  for (let i = table.rows.length - 1; i > 0; i -= 1) {
    table.deleteRow(i);
  }
  LOCAL_CACHE.aiVariables.sort((a, b) => (a.name < b.name ? -1 : 1));
  let rowIndex = 0;

  LOCAL_CACHE.aiVariables.forEach((aiVar) => {
    const style =
      'style="border-bottom-right-radius: 0.35rem; border-top-right-radius: 0.35rem"';
    // we used the delete button as the spinner div when deleting, so give it an id.
    const newRow = `
<tr>
  <td data-id="${aiVar.aiVariableId}">${aiVar.name}</td>
  <td><button type="button" class="btn btn-light editAiVariable" data-toggle="tooltip" title="Edit" ${style}><i class="fa-regular fa-pen-to-square"></i></td>
  <td><button type="button" class="btn btn-light deleteAiVariable" data-toggle="tooltip" title="Delete" id="aiVariablesTableDelete_${rowIndex}" ${style}><i class="fa-regular fa-trash-can"></i></td>
</tr>
`;
    rowIndex += 1;
    $("#aiVariablesTable").append(newRow);
  });
};

// populate the local cache before variableButtons() is called in tinymce

export const getAiVariables = (cache = true) => {
  // call with cache=false to force a read from the API.

  if (cache === true && "aiVariables" in LOCAL_CACHE) {
    return LOCAL_CACHE.aiVariables;
  }
  wrappedGet({
    url: "/api/campaigns/ai_variables",
    success: (res) => {
      LOCAL_CACHE.aiVariables = res.aiVariables;
      setAiVariablesTableContent();
    },
  });
  return LOCAL_CACHE.aiVariables || [];
};

const saveAiVariable = (aiVariable, spinnerDiv) => {
  wrappedPost({
    url: "/api/campaigns/ai_variables",
    data: JSON.stringify(aiVariable),
    spinner: spinnerDiv,
    success: (res) => {
      LOCAL_CACHE.aiVariables = res.aiVariables;
      setAiVariablesTableContent();
    },
  });
};

const saveAiVariableFromEditModal = (deleted = false) => {
  const aiVariable = {
    name: $("#aiVariableName")[0].value,
    aiVariableId: $("#aiVariableName")[0].getAttribute("data-id"),
    prompt: $("#aiVariablePrompt")[0].value,
  };

  let spinnerDiv = "#saveAiVariableButton";
  // append deleted flag, if user clicked delete.
  if (deleted) {
    aiVariable.deleted = true;
    spinnerDiv = "#deleteAiVariableButton";
  } else if (aiVariable.name === "" || aiVariable.prompt === "") {
    // refuse to POST if missing data.
    showToast({
      title: "Invalid AI Variable definition",
      type: "danger",
    });
    return false;
  }

  saveAiVariable(aiVariable, spinnerDiv);
  return true;
};

// Called inside tinymce.js

const showAiVariableEditor = (aiVariableId) => {
  if (aiVariableId) {
    // then we are updating an existing variable.
    $("#editAiVariablesTitle")[0].innerText = "Update AI Variable";
    const aiVariables = getAiVariables();
    const aiVar = aiVariables.find((a) => a.aiVariableId === aiVariableId);
    $("#aiVariableName")[0].value = aiVar.name;
    $("#aiVariableName")[0].setAttribute("data-id", aiVar.aiVariableId);
    $("#aiVariablePrompt")[0].value = aiVar.prompt;
    $("#deleteAiVariableButton").removeClass("d-none");
  } else {
    // we are creating a new variable.
    $("#editAiVariablesTitle")[0].innerText = "Create New AI Variable";
    $("#aiVariableName")[0].value = "";
    $("#aiVariableName")[0].setAttribute("data-id", "");
    $("#aiVariablePrompt")[0].value = "";
    $("#deleteAiVariableButton").addClass("d-none");
  }

  $("#editAiVariableModal").modal("show");
};

// Init modal buttons.
const initAiVariablesModal = () => {
  $("#addNewAiVariableButton").click(() => {
    showAiVariableEditor("");
  });

  const table = $("#aiVariablesTable");
  table.on("click", ".editAiVariable", (event) => {
    const row = $(event.target).closest("tr");
    const aiVariableId = row[0].cells[0].getAttribute("data-id");
    showAiVariableEditor(aiVariableId);
  });
  table.on("click", ".deleteAiVariable", (event) => {
    const row = $(event.target).closest("tr");
    const name = row[0].cells[0].innerText;
    yesNoConfirm(
      `Are you sure you want to this delete AI variable?<br><br>${name}`,
      () => {
        const aiVariableId = row[0].cells[0].getAttribute("data-id");
        const aiVariables = getAiVariables();
        const aiVariable = aiVariables.find(
          (aiVar) => aiVar.aiVariableId === aiVariableId,
        );
        aiVariable.deleted = true;
        saveAiVariable(aiVariable, event.target.id);
      },
    );
  });
};

const initEditAiVariableModal = () => {
  $("#saveAiVariableButton").click(() => {
    if (saveAiVariableFromEditModal()) {
      $("#editAiVariableModal").modal("hide");
    }
  });

  $("#deleteAiVariableButton").click(() => {
    yesNoConfirm("Are you sure you want to delete this AI variable?", () => {
      if (saveAiVariableFromEditModal(true)) {
        $("#editAiVariableModal").modal("hide");
      }
    });
  });
};

export const showAiVariablesModal = () => {
  setAiVariablesTableContent();
  $("#aiVariablesModal").modal("show");
};

export const initializeEditAiVariables = () => {
  getAiVariables(false);

  initAiVariablesModal();

  initEditAiVariableModal();
};
